import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
  lazy,
} from 'react'
import { useRouteMatch, useLocation, useHistory } from 'react-router-dom'
import { Row, Form } from 'react-bootstrap'
import { DesignContext } from 'contexts/DesignContext'
import { HistoryContext } from 'contexts/HistoryContext'
import { ConfigContext } from 'contexts/ConfigContext'
import { useContextMenu } from 'react-contexify'
import objectPath from 'object-path'
import ModalComponent from 'designer/component/component/Modal'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import PathComponent from '../component/PathComponent'
import useAuth from 'hooks/useAuth'
import cloneDeep from 'clone-deep'
import TableButton from './table/TableButton'
import { onCheckCondition } from '../action/condition/Action'
import { createSearchOption, getOptionData } from '../action/Option'
import { compareTwoValue } from '../action/Data'
import { checkPagination } from './table/action/Pagination'
import { calTotal } from './table/action/Total'
import { createSearchParam, genRefId } from './table/action/index'
import { handleRowSelect } from './table/action/SelectRow'
import { onRowTableUpdate } from './table/action/EditRow'
import ModalTable from '../component/ModalTable'
import ModalJsonForm from '../component/ModalJsonForm'
import { createButtonList } from './table/component/TableButtonList'
import { createActionConditionHelper } from './table/helper/ActionCondition'
import { createRowActionHelper } from './table/helper/RowAction'
import { createActionStateHelper } from './table/helper/ActionState'
import { createActionRendererHelper } from './table/helper/ActionRenderer'
import { createSummaryRowHelper } from './table/helper/SummaryRow'
import { createActionRouterHelper } from './table/helper/ActionRouter'
import { createPaginationActionHelper } from './table/helper/PaginationAction'
import { createTableViewResolver } from './table/helper/TableViewResolver'
import { createRowSelectionHelper } from './table/helper/RowSelection'
import {
  createTableDataHelper,
  createTableRefreshHelper,
  createTableChangedHelper,
} from './table/helper/TableData'
import { createTableRenderHelper } from './table/helper/TableRender'
import { createTableColumnHelper } from './table/helper/TableColumn'
import {
  getActionOrder,
  getButtonPosition,
} from './table/helper/TableButtonLayout'
import { createTableTheme } from './table/theme/TableTheme'
import { cancelDebounceCallback } from 'utility/debounceCallback.util'

const TableMenu = lazy(() => import('./table/TableMenu'))
const PrintMenu = lazy(() => import('./table/PrintMenu'))
const TABLE_LOADING_RENDER_DELAY = 120

const CustomTable = (props) => {
  let {
    uischema,
    dynamicData,
    title,
    updateData,
    updateSyncData,
    config,
    fieldName,
    fieldKey,
    isChart,
    chartData,
    uiName,
    value,
    data,
  } = props
  let {
    isFavoriteModal,
    isInputSearchFromPage,
    searchDataFromPage = {},
    jsonData = [],
    isFormComponent,
    formComponent,
    isDynamic,
    isActiveTab = true,
    tabContainerKey,
    tabPaneKey,
  } = config
  const formComponentName = isFormComponent ? formComponent?.name : ''
  const history = useHistory()
  const match = useRouteMatch()
  const location = useLocation()
  let receivePathParams = match.params
  let urlSearchParams = new URLSearchParams(location.search || [])
  let receiveQueryParams = Object.fromEntries([...urlSearchParams])
  let allParams = { ...receivePathParams, ...receiveQueryParams }
  const designContext = useContext(DesignContext)
  const historyContext = useContext(HistoryContext)
  const configContext = useContext(ConfigContext)
  const { layoutType } = configContext.state
  const { formatDate, formatTime, formatDateTime } = useTimeFormat()
  const { user } = useAuth()

  const {
    jsonForm,
    searchData,
    setFormData,
    setComponentPropsData,
    tableRefresh,
    setTableRefresh,
    tabParamActive,
    elementAction,
    getCurrentUi,
    currentSearch,
    isUiChanged,
    setIsUiChanged,
    setFieldFormData,
    callback,
    employeeList,
    getEmployee,
    setSearchData,
    setDatasourceValue,
  } = designContext
  const componentPropsData = objectPath.get(jsonForm, 'componentPropsData')
  const designerData = objectPath.get(componentPropsData, 'data')
  const datasourceValue = objectPath.get(designContext, '@datasource') || {}
  const saveType = objectPath.get(uischema, 'tableAction.saveType')
  const columnRefId = objectPath.get(uischema, 'loadData.columnRefId')
  const uiChanged = objectPath(isUiChanged)
  const isRender =
    uiChanged.get([uischema.key, 'isRender']) || uiChanged.get('isRender')
  const isWaitFetchApiTable = uiChanged.get('isWaitFetchApiTable')
  const tableChanged = uiChanged.get(uischema.key)
  const isFetchTable = uiChanged.get([uischema.key, 'isFetchTable'])
  const isResetAll = uiChanged.get('isResetAll')
  const activeTab = tabContainerKey
    ? uiChanged.get(['activeTab', tabContainerKey])
    : uiChanged.get(['activeTab'])
  const isRefreshTable =
    uiChanged.get('isRefreshTable') ||
    objectPath.get(componentPropsData, 'isRefreshTable')
  const rowSelection = uiChanged.get(['tableSelection', uischema.key]) || []
  const fetchSearch = uiChanged.get('fetchSearch')
  const isUnSelectRow = uiChanged.get([uischema.key, 'isUnSelectRow'])
  const selectedRowFromExternal = uiChanged.get(['selectedRow', uischema.key])
  const isUnselectFromButton = uiChanged.get([
    uischema.key,
    'isUnselectFromButton',
  ])
  let isOpenModal = designContext.openModal
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  let isLoadGET = objectPath.get(uischema, 'loadData.method') === 'GET'
  let isLoadApiGET =
    objectPath.get(uischema, 'loadData.method') === 'API_CONDITION'
  let isLoadPOST = objectPath.get(uischema, 'loadData.method') === 'POST'
  let isLoadSEARCH = objectPath.get(uischema, 'loadData.method') === 'SEARCH'
  let isLoadTABLE = objectPath.get(uischema, 'loadData.method') === 'TABLE'
  let isLoadJSON = objectPath.get(uischema, 'loadData.method') === 'JSON'
  let isLoadSYNC = objectPath.get(uischema, 'loadData.method') === 'SYNC'
  let formData = jsonForm.formData
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let hasActionSelectRow = objectPath.get(elementAction, [
    'actionSelectRowTable',
    uischema.key,
  ])
  let searchOption = useMemo(() => createSearchOption(jsonForm), [])

  let isEnable = hasEnable
    ? objectPath.get(elementAction, ['isEnable', uischema.key])
    : true

  let syncKey = objectPath.get(uischema, 'loadData.syncSetting.key')
  let syncUi = getCurrentUi(syncKey, jsonForm.schema, jsonForm.uischema)
  let syncTable = objectPath.get(formData, syncKey)

  const [tableColumn, setTableColumn] = useState([])
  const [columnRequire, setColumnRequire] = useState([])
  const [detailColumns, setDetailColumns] = useState({})
  const [pageData, setPageData] = useState({
    page: 0,
    rowsPerPage: uischema?.rowsPerPage || 5,
  })
  const [inputSearch, setInputSearch] = useState({})
  const [rowsPerPage, setRowsPerPage] = useState(uischema?.rowsPerPage || 5)
  const [page, setPage] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const loadingFrameRef = useRef(null)
  const loadingTimerRef = useRef(null)
  const [modalAction, setModalAction] = useState({})
  const [isClickButton, setIsClickButton] = useState(false)
  const [isRenderTable, setIsRenderTable] = useState(false)
  const [rowPanelAdd, setRowPanelAdd] = useState([])
  const [searchPath, setSearchPath] = useState('')
  const [searchString, setSearchString] = useState('')
  const [hasSummaryRow, setHasSummaryRow] = useState(false)
  const [dataRowClicked, setDataRowClicked] = useState({})
  const [dataRowSelected, setDataRowSelected] = useState({})
  const [editable, setEditable] = useState({})
  const [tableAction, setTableAction] = useState([])
  const [showAddButton, setShowAddButton] = useState({
    show: false,
    action: null,
  })
  const [showPrintButton, setShowPrintButton] = useState({
    show: false,
    action: null,
  })
  const [printOption, setPrintOption] = useState([])
  const [showSelectionButton, setShowSelectionButton] = useState({
    show: false,
    action: null,
  })
  const [render, setRender] = useState(false)
  const [deletedRowKeys, setDeletedRowKeys] = useState({})
  const [focus, setFocus] = useState({})
  const [openModalTable, setOpenModalTable] = useState(false)
  const [modalTableState, setModalTableState] = useState({})

  const tableRef = useRef()
  const addActionRef = useRef()
  const [changeSearch, setChangeSearch] = useState(false)

  const clearLoadingDelay = () => {
    if (
      loadingFrameRef.current !== null &&
      typeof window !== 'undefined' &&
      window.cancelAnimationFrame
    ) {
      window.cancelAnimationFrame(loadingFrameRef.current)
      loadingFrameRef.current = null
    }
    if (loadingTimerRef.current !== null) {
      clearTimeout(loadingTimerRef.current)
      loadingTimerRef.current = null
    }
  }

  const setTableLoading = (isLoading) => {
    clearLoadingDelay()
    if (isLoading) {
      setLoading(true)
      return
    }

    if (typeof window !== 'undefined' && window.requestAnimationFrame) {
      loadingFrameRef.current = window.requestAnimationFrame(() => {
        loadingFrameRef.current = window.requestAnimationFrame(() => {
          loadingFrameRef.current = null
          loadingTimerRef.current = setTimeout(() => {
            setLoading(false)
            loadingTimerRef.current = null
          }, TABLE_LOADING_RENDER_DELAY)
        })
      })
    } else {
      loadingTimerRef.current = setTimeout(() => {
        setLoading(false)
        loadingTimerRef.current = null
      }, TABLE_LOADING_RENDER_DELAY)
    }
  }

  useEffect(() => {
    return () => {
      if (
        loadingFrameRef.current !== null &&
        typeof window !== 'undefined' &&
        window.cancelAnimationFrame
      ) {
        window.cancelAnimationFrame(loadingFrameRef.current)
      }
      if (loadingTimerRef.current !== null) {
        clearTimeout(loadingTimerRef.current)
      }
    }
  }, [])

  // ======== TABLE CONFIG ======== //

  const tableColumnList = objectPath.get(uischema, 'tableColumn') || []
  const elementTableColumn = tableColumnList.filter(
    ({ valueType }) => valueType === 'element',
  )
  const tableBaseProps = {
    uischema,
    jsonForm,
    formData,
    designContext,
    historyContext,
    allParams,
    user,
  }
  const tableSetterProps = {
    setLoading: setTableLoading,
    setRender,
    setIsUiChanged,
    setFormData,
    setFieldFormData,
    setComponentPropsData,
    setTotalCount,
  }
  const tableLoadProps = {
    isLoadGET,
    isLoadPOST,
    isLoadApiGET,
    isLoadSEARCH,
    isLoadTABLE,
    isLoadJSON,
    isLoadSYNC,
  }

  // ======== TABLE DATA ======== //

  const { setTableData, getJsonTable } = createTableDataHelper({
    ...tableBaseProps,
    ...tableLoadProps,
    updateData,
    isFavoriteModal,
    jsonData,
    isChart,
    chartData,
    syncKey,
    formComponentName,
    isDynamic,
    dynamicData,
  })

  const tableData = getJsonTable()
  const jsonTable = tableData

  const getTableRowKey = (rowData = {}) => {
    const genId = objectPath.get(rowData, genRefId)
    const rowRefId = columnRefId ? objectPath.get(rowData, columnRefId) : ''
    const rowId = objectPath.has(rowData, 'id') ? rowData.id : ''
    const tableNo = objectPath.get(rowData, 'tableData.no')
    const tableId = objectPath.get(rowData, 'tableData.id')
    const isGeneratedRowId =
      rowId !== undefined &&
      rowId !== null &&
      rowId !== '' &&
      ((tableNo !== undefined &&
        tableNo !== null &&
        `${rowId}` === `${tableNo}`) ||
        (tableId !== undefined &&
          tableId !== null &&
          `${rowId}` === `${tableId + 1}`))

    if (genId !== undefined && genId !== null && genId !== '') {
      return `gen:${genId}`
    }
    if (rowRefId !== undefined && rowRefId !== null && rowRefId !== '') {
      return `ref:${rowRefId}`
    }
    if (
      rowId !== undefined &&
      rowId !== null &&
      rowId !== '' &&
      !isGeneratedRowId
    ) {
      return `id:${rowId}`
    }

    const rowValue = cloneDeep(rowData || {})
    objectPath.del(rowValue, 'tableData')
    objectPath.del(rowValue, '@seq')
    if (isGeneratedRowId) {
      objectPath.del(rowValue, 'id')
    }

    return `row:${JSON.stringify(rowValue)}`
  }

  const visibleTableData = useMemo(() => {
    if (!Array.isArray(tableData)) return []

    return tableData.filter((rowData) => {
      if (objectPath.get(rowData, '@isDeleted')) return false

      const rowKey = getTableRowKey(rowData)

      return !deletedRowKeys[rowKey]
    })
  }, [JSON.stringify(tableData), JSON.stringify(deletedRowKeys), uischema.key])

  const [reorderTable, setReorderTable] = useState(tableData)

  // ======== TABLE STATE ======== //

  const search = useMemo(() => {
    let search = jsonForm.search || {}
    let searchTable = jsonForm.searchTable || []
    let foundSearch = searchTable.find(
      ({ tableKey }) => tableKey === uischema.key,
    )
    if (foundSearch) {
      search = foundSearch
    } else if (currentSearch?.uiKey && currentSearch?.search) {
      search = currentSearch?.search
      setChangeSearch(currentSearch?.uiKey)
    }
    return search
  }, [currentSearch?.uiKey])

  const hasSearchValue = (value) =>
    value !== undefined &&
    value !== null &&
    value !== '' &&
    (!Array.isArray(value) || value.length > 0)

  const getSearchValue = (data = {}, keyList = []) => {
    let foundKey = keyList.find((key) => key && objectPath.has(data, key))

    return {
      hasValue: Boolean(foundKey),
      value: foundKey ? objectPath.get(data, foundKey) : undefined,
    }
  }

  const searchFormData = (search?.field || []).reduce(
    (data, { key, name }) => {
      let searchValueData = getSearchValue(formData, [key, name])
      if (searchValueData.hasValue) {
        if (key) data[key] = searchValueData.value
        if (name) data[name] = searchValueData.value
      }
      return data
    },
    {},
  )
  const tableFetchSearch =
    fetchSearch === undefined && Object.keys(searchFormData).length === 0
      ? undefined
      : { ...(fetchSearch || {}), ...searchFormData }
  const tableFetchSearchString = JSON.stringify(tableFetchSearch)
  const tableDebounceName = [
    'load-by-get',
    location.key || `${location.pathname}${location.search}`,
    tabPaneKey,
    uischema.key,
  ]
    .filter(Boolean)
    .join('-')

  const isWaitSearchOption = (search?.field || []).some(({ key, name }) => {
    let searchUi = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (searchUi?.tagname !== 'select') return false

    let hasDefaultValue = hasSearchValue(searchUi.defaultValue)
    if (!hasDefaultValue) return false

    let searchKeyList = [key, name]
    let searchValueData = getSearchValue(fetchSearch, searchKeyList)
    if (!searchValueData.hasValue) {
      searchValueData = getSearchValue(searchData, searchKeyList)
    }
    if (!searchValueData.hasValue) {
      searchValueData = getSearchValue(formData, searchKeyList)
    }

    if (
      searchUi.isAll &&
      !hasSearchValue(searchValueData.value) &&
      !hasSearchValue(searchUi.allValue)
    ) {
      return false
    }

    if (
      searchUi.isAll &&
      searchValueData.hasValue &&
      compareTwoValue(
        'equalValue',
        searchValueData.value,
        searchUi.allValue,
        true,
      )
    ) {
      return false
    }

    return !hasSearchValue(searchValueData.value)
  })

  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  const rowsPerPageOptions = useMemo(() => {
    let array = [5, 10, 20]
    if (uischema?.rowsPerPage) {
      setRowsPerPage(uischema?.rowsPerPage)
      if (!array.includes(uischema?.rowsPerPage)) {
        array.push(uischema?.rowsPerPage)
      }
    }
    return array.sort((a, b) => a - b)
  }, [uischema?.rowsPerPage])

  const checkAll = useMemo(() => {
    if (rowSelection && tableData) {
      return rowSelection.length > 0 && rowSelection.length === tableData.length
    }
    return false
  }, [JSON.stringify(rowSelection)])

  const actionOrder = useMemo(() => {
    return getActionOrder(uischema)
  }, [JSON.stringify(uischema?.tableAction)])

  let buttonPosition = useMemo(() => {
    return getButtonPosition(actionOrder)
  }, [JSON.stringify(uischema?.tableAction)])

  let propAction = {
    value,
    jsonTable,
    data,
    formComponentName,
    uiName,
    config,
    search,
    designContext,
    uischema,
    isLoadSYNC,
    syncKey,
    syncUi,
    syncName: syncKey === syncUi ? syncUi.name : syncKey,
    stateParent: {
      inputSearch: [inputSearch, setInputSearch],
      tableData: [tableData, setTableData],
      totalCount: [totalCount, setTotalCount],
      loading: [loading, setTableLoading],
      render: [render, setRender],
    },
    updateData,
    updateSyncData,
    formData,
  }
  let localization = {
    header: {
      actions: uischema?.tableAction?.actionLabel ?? 'Actions',
    },
    toolbar: {
      searchPlaceholder: uischema?.tableAction?.searchLabel ?? 'ค้นหา',
    },
  }

  const isPagination = useMemo(
    () => (uischema?.loadData ? checkPagination(propAction) : false),
    [uischema.key],
  )

  const { enableSelectionButton = false } =
    uischema?.tableAction?.selection || {}

  // ======== TABLE MENU ======== //

  const { show } = useContextMenu({
    id: 'menuId',
    props: {
      key: 'value',
    },
  })

  const displayTableMenu = (e) =>
    show(e, {
      id: 'table-menu',
    })

  const displayPrintMenu = (e) =>
    show(e, {
      id: 'print-menu',
    })

  // ======== TABLE HELPERS ======== //

  const {
    checkLockAction,
    checkHiddenAction,
    applyEditableConditions,
  } = createActionConditionHelper({
    ...tableBaseProps,
    tableColumnList,
    datasourceValue,
    tabParamActive,
  })
  const { applySelectionAction, showAddAction } = createActionStateHelper({
    setShowAddButton,
    setShowSelectionButton,
  })
  const { checkHasSummaryRow, renderSummaryRow } = createSummaryRowHelper({
    ...tableBaseProps,
    tableColumnList,
    setHasSummaryRow,
    totalCount,
  })

  const tableTheme = createTableTheme({
    ...tableBaseProps,
    layoutType,
    title,
  })
  const { renderTableData, checkRenderTable } = createTableRenderHelper({
    ...tableBaseProps,
    ...tableSetterProps,
    ...tableLoadProps,
    page,
    rowsPerPage,
    isWaitFetchApiTable,
    isWaitSearchOption,
    isUiChanged,
    receiveQueryParams,
    datasourceValue,
    setDatasourceValue,
    search,
    setIsRenderTable,
    updateData,
    setTableData,
    refreshTableData: (...params) => refreshTableData(...params),
    getPropTable: () => propTable,
    fetchSearch: tableFetchSearch,
    jsonTable,
    propAction,
    syncTable,
    isRefreshTable,
    isResetAll,
    activeTab,
    setPage,
    pageData,
    setPageData,
    tableDebounceName,
  })

  const onAction = {
    setLoading: setTableLoading,
    setPage: setPage,
    setRowsPerPage: setRowsPerPage,
    setTotalCount: setTotalCount,
    setTableColumn: setTableColumn,
    setTableData: setTableData,
    setSearchPath: setSearchPath,
    setSearchString: setSearchString,
    setModalAction: setModalAction,
    setComponentPropsData: setComponentPropsData,
    setFormData: setFormData,
    updateData: updateData,
    renderTableData: renderTableData,
    onRowTableUpdate: onRowTableUpdate,
  }

  let propTable = {
    pagination: { page: page, rowsPerPage: rowsPerPage },
    formData: { ...formData, ...searchData, ...searchDataFromPage },
    fetchSearch: tableFetchSearch,
    allParams,
    designerData,
    tabParamActive,
    componentPropsData,
    search,
    dynamicData,
    onAction,
    inputSearch,
    searchPath,
    searchString,
    tableData,
    isRefreshTable,
    loading,
    isSearchRequest: isLoadSEARCH,
    elementTableColumn,
    designContext,
    historyContext,
    uischema,
    history,
  }
  const {
    handleChangeRowsPerPage,
    handleChangePage,
  } = createPaginationActionHelper({
    ...tableBaseProps,
    ...tableSetterProps,
    ...tableLoadProps,
    tableRef,
    propTable,
    tableData,
    search,
    pageData,
    isUiChanged,
    setPage,
    setRowsPerPage,
    setPageData,
    setIsRenderTable,
    tableDebounceName,
  })
  const { TableView, tableViewProps } = createTableViewResolver({
    ...tableBaseProps,
    ...tableLoadProps,
    saveType,
    fieldKey,
    fieldName,
  })
  const {
    createClickRow,
    selectRow,
    handleRowSelectAll,
    syncSelectedRow,
  } = createRowSelectionHelper({
    ...tableBaseProps,
    ...tableSetterProps,
    props,
    columnRefId,
    dataRowClicked,
    setDataRowClicked,
    isUiChanged,
    componentPropsData,
    designerPropsData,
    tableData,
  })
  const {
    onRowDefaultAction,
    getApiRowProps,
    getAction,
  } = createActionRouterHelper({
    ...tableBaseProps,
    ...tableSetterProps,
    renderTableData,
    setModalAction,
    history,
    location,
    formatDate,
    formatTime,
    formatDateTime,
    callback,
    setDataRowClicked,
    isUiChanged,
    selectRow,
    createClickRow,
  })
  const {
    refreshTableData,
    rerenderTable,
    handleTableRefresh,
  } = createTableRefreshHelper({
    ...tableBaseProps,
    ...tableSetterProps,
    ...tableLoadProps,
    receivePathParams,
    receiveQueryParams,
    designerData,
    datasourceValue,
    propAction,
    tableRefresh,
    jsonTable,
    syncTable,
    syncSelectedRow,
    setTableRefresh,
    setDataRowClicked,
    isUiChanged,
  })
  const { handleTableChanged } = createTableChangedHelper({
    ...tableBaseProps,
    ...tableSetterProps,
    tableChanged,
    uiChanged,
    renderTableData,
  })
  const {
    appendPrintAction,
    createEditRowAction,
    createDeleteRowAction,
    applyOptionalActions,
  } = createRowActionHelper({
    isReadOnly,
    propTable,
    propAction,
    displayPrintMenu,
    displayTableMenu,
    setDataRowSelected,
    setShowPrintButton,
    setPrintOption,
    checkHiddenAction,
    checkLockAction,
    onRowDefaultAction: (...params) => onRowDefaultAction(...params),
  })
  const { renderActionBySaveType } = createActionRendererHelper({
    isReadOnly,
    propAction,
    showAddAction,
    appendPrintAction,
    createEditRowAction,
    createDeleteRowAction,
    onRowDefaultAction: (...params) => onRowDefaultAction(...params),
    getApiRowProps: (...params) => getApiRowProps(...params),
  })

  // ======== TABLE HANDLERS ======== //

  const renderAction = (column, rowData = {}) => {
    let { rowTableAction, newEditable } = renderActionBySaveType(column, rowData)
    rowTableAction = applyOptionalActions(column, rowTableAction)
    applySelectionAction(column)
    newEditable = applyEditableConditions(newEditable)
    setTableAction(rowTableAction)
    setEditable(newEditable)
  }

  const isSoftDeleteAction = useMemo(() => {
    let deleteAction = (uischema?.tableAction?.action || []).find(
      ({ name, isActive }) => name === 'delete' && isActive,
    )
    let method = deleteAction?.method || ''
    method = method.toLowerCase()

    return (
      deleteAction?.action === 'updateStatus' ||
      deleteAction?.statusField ||
      (method && method !== 'delete')
    )
  }, [JSON.stringify(uischema?.tableAction?.action)])

  const tableEditable = useMemo(() => {
    if (!editable?.onRowDelete || isSoftDeleteAction) return editable

    return {
      ...editable,
      onRowDelete: (oldData) => {
        const rowKey = getTableRowKey(oldData)

        setDeletedRowKeys((previousKeys) => ({
          ...previousKeys,
          [rowKey]: true,
        }))

        return Promise.resolve(editable.onRowDelete(oldData)).catch((error) => {
          setDeletedRowKeys((previousKeys) => {
            const nextKeys = { ...previousKeys }

            delete nextKeys[rowKey]

            return nextKeys
          })
          throw error
        })
      },
    }
  }, [editable, isSoftDeleteAction, uischema.key])

  const onOpenModalTable = (rowData, column, altModal) => {
    setOpenModalTable(!openModalTable)
    setModalTableState({ rowData, column, altModal })
  }

  const { createTableColumn } = createTableColumnHelper({
    ...tableBaseProps,
    ...tableSetterProps,
    tableColumnList,
    rowSelection,
    checkAll,
    handleRowSelectAll,
    propAction,
    tabParamActive,
    tableData,
    setTableData,
    focus,
    setFocus,
    modalAction,
    setModalAction,
    isClickButton,
    setIsClickButton,
    columnRequire,
    setColumnRequire,
    tableRef,
    location,
    history,
    formatDate,
    formatTime,
    formatDateTime,
    renderTableData,
    onOpenModalTable,
    setDetailColumns,
    setTableColumn,
  })

  // ======== TABLE EFFECTS ======== //

  useEffect(() => {
    if (isLoadJSON) {
      calTotal(jsonTable, propAction)
    }
  }, [JSON.stringify(jsonTable), JSON.stringify(tableColumnList)])

  useEffect(() => {
    if (isLoadSYNC) {
      calTotal(syncTable, propAction)
    }
  }, [JSON.stringify(syncTable), JSON.stringify(tableColumnList)])

  useEffect(() => {
    checkHasSummaryRow()
  }, [JSON.stringify(tableColumnList)])

  useEffect(() => {
    if (hasActionSelectRow) {
      let rowData = objectPath.get(tableData, 0)
      if (rowData) {
        selectRow(uischema.action, rowData)
      }
    }
  }, [hasActionSelectRow])

  useEffect(() => {
    if (isLoadJSON && render) {
      rerenderTable(jsonTable)
    }
  }, [JSON.stringify(jsonTable)])

  useEffect(() => {
    if (isLoadSYNC && render) {
      rerenderTable(syncTable)
    }
  }, [JSON.stringify(syncTable)])

  useEffect(() => {
    if (isRender) {
      rerenderTable()
      uiChanged.del([uischema.key, 'isRender'])
      setIsUiChanged(uiChanged.get(''))
    }
  }, [isRender])

  useEffect(() => {
    if (isUnSelectRow) {
      rerenderTable(jsonTable)
      uiChanged.del([uischema.key, 'isUnSelectRow'])
      setIsUiChanged(uiChanged.get(''))
    }
  }, [isUnSelectRow])

  useEffect(() => {
    objectPath.set(isUiChanged, 'urlParams', allParams)
  }, [location.search])

  useEffect(() => {
    if (render) {
      setRender(false)
    }
  }, [render])

  useEffect(() => {
    if (isUnselectFromButton) {
      setDataRowClicked({})
      objectPath.del(isUiChanged, [uischema.key, 'isUnselectFromButton'])
      setIsUiChanged(isUiChanged)
    }
  }, [isUnselectFromButton])

  useEffect(() => {
    if (selectedRowFromExternal) {
      getAction(selectedRowFromExternal)
      objectPath.del(isUiChanged, ['selectedRow', uischema.key])
      setIsUiChanged(isUiChanged)
    }
  }, [selectedRowFromExternal])

  useEffect(() => {
    let hasEmployee = tableColumnList.find(
      ({ type }) => type === 'userId' || type === 'employeeCode',
    )
    if (jsonForm?.formCode && employeeList.length === 0 && hasEmployee) {
      getEmployee()
    }
  }, [jsonForm?.formCode])

  useEffect(() => {
    if (uischema && uischema.tableAction && isEnable) {
      setShowAddButton({
        show: false,
        action: null,
      })
      setShowPrintButton({
        show: false,
        action: null,
      })
      renderAction(uischema.tableAction)
    } else {
      renderAction({})
    }
  }, [JSON.stringify(uischema?.tableAction), isEnable])

  useEffect(createTableColumn, [
    JSON.stringify(tableData),
    JSON.stringify(tableColumnList),
    JSON.stringify(employeeList),
    uischema.rowPadding,
    uischema.defaultSort,
    uischema.sortField,
    JSON.stringify(rowSelection),
    checkAll,
  ])

  useEffect(() => {
    tableColumnList.forEach((column) => {
      if (column.typeField === 'select') {
        getOptionData({
          designContext,
          selectAction: column,
          data: formData,
        })
      }
    })
  }, [])

  useEffect(() => {
    if (changeSearch) {
      setChangeSearch(false)
    }
  }, [changeSearch])

  useEffect(() => {
    return () => {
      objectPath.set(isUiChanged, ['tableSelection', uischema.key], [])
      setIsUiChanged(isUiChanged)
    }
  }, [uischema.key])

  useEffect(() => {
    if (!inputSearch) {
      if (Object.values(searchData).filter((values) => values).length > 0) {
        createSearchParam(fetchSearch, propAction)
      } else if (fetchSearch) {
        createSearchParam(fetchSearch, propAction)
        setSearchData(fetchSearch)
      }
    }
  }, [JSON.stringify(fetchSearch), JSON.stringify(searchData)])

  useEffect(() => {
    if (isFetchTable) {
      renderTableData(uischema, false, isFetchTable)
      uiChanged.del([uischema.key, 'isFetchTable'])
      setIsUiChanged(uiChanged.get(''))
    }
  }, [isFetchTable])

  useEffect(() => {
    if (fetchSearch === undefined) {
      objectPath.set(isUiChanged, 'fetchSearch', searchData)
      setIsUiChanged(isUiChanged)
    }
  }, [fetchSearch])

  useEffect(() => {
    if (isActiveTab) {
      checkRenderTable()
    }
  }, [
    tableFetchSearchString,
    location.key,
    location.pathname,
    location.search,
    isInputSearchFromPage,
    isResetAll,
    isRefreshTable,
    isWaitSearchOption,
    isActiveTab,
    JSON.stringify(activeTab),
  ])

  useEffect(() => {
    return () => cancelDebounceCallback(tableDebounceName)
  }, [tableDebounceName])

  useEffect(() => {
    objectPath.set(isUiChanged, ['pageTable', uischema.key], {
      page,
      rowsPerPage,
    })
    setIsUiChanged(isUiChanged)
  }, [page, rowsPerPage])

  useEffect(() => {
    if (isRefreshTable) {
      objectPath.set(isUiChanged, 'fetchSearch', searchData)
      setComponentPropsData({ isRefreshTable: false })
      objectPath.set(isUiChanged, 'isRefreshTable', false)
      objectPath.set(isUiChanged, 'lockPagination', true)
      setIsUiChanged(isUiChanged)
      onCheckCondition(designContext, formData, uischema.key, {
        isSelectRow: false,
      })
    }
  }, [isRefreshTable])

  useEffect(async () => {
    await handleTableChanged()
  }, [tableChanged])

  useEffect(() => {
    handleTableRefresh()
  }, [tableRefresh.length])

  // ======== TABLE RENDER ======== //

  const buttonList = createButtonList({
    ...tableBaseProps,
    isReadOnly,
    isEnable,
    enableSelectionButton,
    tableColumn,
    showAddButton,
    rowPanelAdd,
    setRowPanelAdd,
    setLoading,
    handleChangePage,
    onRowDefaultAction,
    addActionRef,
    page,
    rowsPerPage,
    totalCount,
    showPrintButton,
    rowSelection,
    showSelectionButton,
    renderTableData,
  })

  return (
    <>
      <TableButton
        uischema={uischema}
        actionOrder={actionOrder}
        buttonList={buttonList}
        buttonPosition={buttonPosition}
        data={cloneDeep(tableData)}
        config={config}
      />
      <div
        style={{
          maxHeight: uischema.maxHeight || '100%',
          minHeight: uischema.minHeight || 'auto',
          overflowY: 'auto',
          boxShadow: '1px 1px 6px 0px #d7d7d7',
        }}
      >
        <TableView
          {...tableViewProps}
          localization={localization}
          title={title}
          editable={tableEditable}
          tableAction={tableAction}
          tableColumn={tableColumn}
          dataTable={visibleTableData}
          tableRef={tableRef}
          uischema={uischema}
          formData={formData}
          setModalAction={setModalAction}
          renderTableData={renderTableData}
          tableColumnList={tableColumnList}
          loading={loading}
          detailColumns={detailColumns}
          rowsPerPageOptions={rowsPerPageOptions}
          page={page}
          pageData={pageData}
          setPage={setPage}
          setPageData={setPageData}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalCount={totalCount}
          setTotalCount={setTotalCount}
          tableTheme={tableTheme}
          addActionRef={addActionRef}
          dataRowClicked={dataRowClicked}
          isPagination={isPagination}
          allParams={allParams}
          getAction={getAction}
          isClickButton={isClickButton}
          setIsClickButton={setIsClickButton}
          setTableData={setTableData}
          setLoading={setTableLoading}
          isRenderTable={isRenderTable}
          setIsRenderTable={setIsRenderTable}
          rowPanelAdd={rowPanelAdd}
          setRowPanelAdd={setRowPanelAdd}
          jsonForm={jsonForm}
          setComponentPropsData={setComponentPropsData}
          rowSelection={rowSelection}
          handleRowSelect={handleRowSelect}
          renderSummaryRow={hasSummaryRow ? renderSummaryRow : null}
          propAction={propAction}
          reorderTable={reorderTable}
          setReorderTable={setReorderTable}
        />
      </div>

      {rowSelection.length > 0 && (
        <Row
          className="pb-0 pt-2 px-3 mt-2 mb-1 w-100 mx-auto"
          style={{ backgroundColor: '#fff5e8' }}
        >
          <Form.Label
            className="text-warning font-weight-bold"
            style={{ fontSize: '18px' }}
          >
            {rowSelection.length} row(s) selected
          </Form.Label>
        </Row>
      )}
      <TableMenu
        option={
          uischema && uischema.tableAction && uischema.tableAction.optional
            ? uischema.tableAction.optional
            : []
        }
        dataSelected={dataRowSelected}
        uischema={uischema}
        renderTableData={renderTableData}
        setModalAction={setModalAction}
        onRowTableUpdate={onRowTableUpdate}
        genRefId={genRefId}
        columnRefId={columnRefId}
        propAction={propAction}
      />
      <PrintMenu
        option={printOption || []}
        dataSelected={dataRowSelected}
        uischema={uischema}
      />
      <ModalComponent
        ui={uischema}
        modalAction={modalAction}
        isOpenModal={isOpenModal === uischema.key}
        onRefreshTable={renderTableData}
        designerPropsData={designerPropsData}
      />
      <ModalTable
        state={modalTableState}
        setState={setModalTableState}
        ui={uischema}
        modalAction={modalAction}
        isOpenModal={openModalTable}
        setIsOpenModal={setOpenModalTable}
        onRefreshTable={renderTableData}
        designerPropsData={designerPropsData}
      />
      <ModalJsonForm />
      <PathComponent />
    </>
  )
}

export default CustomTable
